<template>
  <div class="reset-change-password-div">
    <Dialog :header="$t('resetChangePassword.changepassword')" :visible="showChangeDialog" :style="{'max-width': '30em'}"
            :position="position" :closable="false" :modal="true" :draggable="false">
      <div class="grid change-password-box">
        <div class="col-12">
          <span class="p-float-label">
                        <Password autocomplete="new-password" toggleMask v-model="newPassword"/>
                        <label>{{ $t('resetChangePassword.newpassword') }}</label>
          </span>
        </div>
        <div class="col-12">
          <span class="p-float-label">
                        <Password autocomplete="new-password" toggleMask v-model="confirmNewPassword"/>
                        <label>{{ $t('resetChangePassword.confirmnewpassword') }}</label>
          </span>
        </div>
      </div>
      <template #footer>
        <Button icon="pi pi-check" :label="$t('resetChangePassword.save')" @click="changePassword"/>
      </template>
    </Dialog>
    <Accordion class="changeresetbox">
      <AccordionTab :disabled="loading" :header="$t('resetChangePassword.resetpassword')">
        <div class="grid">
                <div class="col-12">
                    <Button :disabled="loading" :label="$t('resetChangePassword.reset-password')" icon="pi pi-inbox" @click="resetPassword"/>
        </div>
      </div>
      </AccordionTab>
      <AccordionTab :disabled="loading" :header="$t('resetChangePassword.recoverusername')">
        <div class="grid">
          <div class="col-12">
            <InputText :class="(isValidMail === true ? '' : 'p-invalid')" :placeholder="$t('login.email')" v-model="email" @keyup.enter="recoverUsername" />
            <Button :disabled="loading" :label="$t('resetChangePassword.recover-username')" icon="pi pi-inbox" style="margin-top: .5em" @click="recoverUsername"/>
          </div>
        </div>
      </AccordionTab>
  </Accordion>
  </div>
</template>

<script>
import LoginService from "../../service/LoginService";
import {useLoadingStore} from "@/store/loadingStore";

export default {
  name: "ResetChangePassword",
  props: {
            user: Object,
            refreshUsername: Number,
            showChangeDialogOriginal: Boolean
  },
  setup() {
    const loadingStore = useLoadingStore()
    return {
      loadingStore,
    }
  },
  data() {
    return {
      userData: this.user,
      showChangeDialog: false,
      username: null,
      password: null,
      newPassword: null,
      confirmNewPassword: null,
      email:null,
      isValidMail:true,
      position: "top"
    }
  },
  methods: {
    validateEmail() {
      this.isValidMail = !(this.email == null || !/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,50})+$/.test(this.email));
      return this.isValidMail
    },
    openChangeDialog(){
      this.resetUser()
      this.showChangeDialog = true
    },
    resetUser(){
      this.username = this.user.username
      this.password = null
      this.newPassword = null
      this.confirmNewPassword = null
    },
    closeChangeResetPassword(){
      this.showChangeDialog = false;
    },
    changePassword() {
              this.userData.username = this.username;
              this.userData.password = this.password;
              this.userData.newPassword = this.newPassword;
              this.userData.confirmNewPassword = this.confirmNewPassword;
      if (this.userData.username == null || this.userData.password == null || this.userData.newPassword == null || this.userData.confirmNewPassword == null) {
        this.$toast.add({
          severity: "warn",
          summary: this.$t("toasts.changePasswordNullField.summary"),
          detail: this.$t("toasts.changePasswordNullField.detail"),
                        life: 4000
        });
      } else if (this.userData.newPassword !== this.userData.confirmNewPassword) {
        this.$toast.add({
          severity: "warn",
          summary: this.$t("toasts.changePasswordNotEquals.summary"),
          detail: this.$t("toasts.changePasswordNotEquals.detail"),
                        life: 4000
        });
      } else {
        this.loadingStore.startLoading();
        this.loginService.changePassword(this.user).then((data) => {
          this.loadingStore.stopLoading();
          this.$toast.add({
            severity: this.$t("toasts."+data+".severity"),
            summary: this.$t("toasts."+data+".summary"),
            detail: this.$t("toasts."+data+".detail"),
                            life: 60000
          });
                        if(data === 'VALID'){
                          this.userData.password = this.newPassword
                          this.$emit('login',this.user)
                        }
        }).catch(e => {
         this.loadingStore.resetLoading();
          this.$toast.add({
            severity: "error",
            summary: this.$t("toasts.changePasswordError.summary"),
            detail: this.$t("toasts.changePasswordError.detail"),
                            life: 4000
          });
          console.log("error changePassword", e);
        });
      }
    },
    recoverUsername() {
      if(this.validateEmail()){
        this.isValidMail = true;
        this.userData.application = "assicurati-credito";
        this.userData.email = this.email;
        if (this.userData.email == null || this.userData.email === '') {
          this.$toast.add({
            severity: "warn",
            summary: this.$t("toasts.recoverUsernameNullField.summary"),
            detail: this.$t("toasts.recoverUsernameNullField.detail"),
            life: 4000
          });
        } else {
          this.loadingStore.startLoading();
          this.loginService.recoverUsername(this.user).then(() => {
            this.loadingStore.stopLoading();
            this.userData.password = null;
            this.$toast.add({
              severity: "info",
              summary: this.$t("toasts.recoverUsernameSuccess.summary"),
              detail: this.$t("toasts.recoverUsernameSuccess.detail"),
              life: 4000
            });
          }).catch(e => {
           this.loadingStore.resetLoading();
            this.$toast.add({
              severity: "error",
              summary: this.$t("toasts.recoverUsernameError.summary"),
              detail: this.$t("toasts.recoverUsernameError.detail"),
              life: 4000
            });
            console.log("error recoverUsername", e);
          });
        }
      } else {
        this.$toast.add({
          severity: "error",
          summary: this.$t("toasts.invalidMail.summary"),
          detail: this.$t("toasts.invalidMail.detail"),
          life: 4000
        });
      }
    },
    resetPassword() {
              this.userData.application = "assicurati-credito";
              if (this.userData.username == null || this.userData.username === '') {
        this.$toast.add({
          severity: "warn",
          summary: this.$t("toasts.resetPasswordNullField.summary"),
          detail: this.$t("toasts.resetPasswordNullField.detail"),
                        life: 4000
        });
      } else {
        this.loadingStore.startLoading();
        this.loginService.resetPassword(this.user).then(() => {
          this.loadingStore.stopLoading();
                      this.userData.password = null;
          this.$toast.add({
            severity: "info",
            summary: this.$t("toasts.resetPasswordSuccess.summary"),
            detail: this.$t("toasts.resetPasswordSuccess.detail"),
                            life: 4000
          });
        }).catch(e => {
         this.loadingStore.resetLoading();
          this.$toast.add({
            severity: "error",
            summary: this.$t("toasts.resetPasswordError.summary"),
            detail: this.$t("toasts.resetPasswordError.detail"),
                            life: 4000
          });
          console.log("error resetPassword", e);
        });
      }
    }
  },
  computed:{
    loading () { return this.loadingStore.loading }
  },
  watch:{
    user(){
      this.userData = this.user;
      this.username = this.user.username
      this.password = this.user.password
    },
    showChangeDialogOriginal(){
      this.showChangeDialog = this.showChangeDialogOriginal
    }
  },
  created() {
    this.loginService = new LoginService();
  }
}
</script>

<style lang="scss">
.reset-change-password-div{
  margin-top: 1em;
}
.p-password,input {
  width: 100%;
}
.change-password-box{
  div{
    margin-top: 0.5em;
  }
}
.change-password{
  text-align: left;
  background-color:transparent!important;
  border: none!important;
  color: #43c3bf!important;
  margin-bottom: 1em!important;
  padding-left: 0;
}
.changeresetbox {
  .p-accordion-header {
    background-color: inherit !important;
    .p-accordion-header-text {
      color: #43c3bf;
      font-weight: 400;
    }

    a {
      padding: 0.3em !important;
      padding-left: 0 !important;
      border: none !important;
      background-color: inherit !important;
    }

    .p-accordion-toggle-icon {
      display: none;
    }

    &:not(.p-highlight):not(.p-disabled):hover {
      color: inherit !important;

      a {
        background-color: inherit !important;
        border: none !important;
      }
    }

    &:not(.p-disabled).p-highlight {
      margin-bottom: 0;
      color: inherit !important;

      a {
        background-color: inherit !important;
        border: none !important;
      }

      &:hover {
        a {
          background-color: inherit !important;
          border: none !important;
        }
      }
    }
  }

  .p-accordion-content {
    background-color: inherit !important;
    border: none !important;
    padding: 0 !important;
            margin-top: 0.5em;
  }

  margin-top: -1em;
  padding-left: 0 !important;
}

</style>
